import { AppEnvironment } from '../app/config/environment.token';

export const environment: AppEnvironment = {
  apiUrl: 'https://api-dev.organizae.app.br',
};
